import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { AdditionalQuestionService } from '../services/additional-questions.service';
import { DatePipe } from '@angular/common';
import { MasterDataService } from '../services/masterdata.service';

@Component({
    selector: 'app-additional-questions',
    templateUrl: './additional-questions.component.html',
    styleUrls: ['./additional-questions.component.css'],
    providers: [DatePipe],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AdditionalQuestionsComponent implements OnInit {
    public validateDate: boolean = false;
    public validated: boolean = false;
    public validateSet: boolean = false;
    public validateFromDate: boolean = false;
    public validateToDate: boolean = false;
    public setData: any = [];
    public selectedFromDate: any;
    public selectedToDate: any;
    public selectedData: any = [];
    public startDate: any;
    public endDate: any;
    public selectedName: any;
    public disabledDates: NgbDateStruct[] = []
    public model: NgbDateStruct;
    public date: { year: number, month: number };
    showLoader: boolean = false;
    public selectedSet: any = 0;
    public fromvalidateDate: boolean = true;
    public tovalidateDate: boolean = true;
    public displayVersionField: boolean = false;
    public selectedVersion: any = 0;
    public validateVersion: boolean = false;
    constructor(private http: HttpClient, private additionalservice: AdditionalQuestionService, private datePipe: DatePipe, private masterDataService: MasterDataService) {
        
    }

    ngOnInit() {
        
        this.getSetDropdown();
        this.autoPopulateOnTabChange();
    }

    public getSetDropdown() {
        this.additionalservice.getSetDropdown().subscribe(x => { this.setData = x; console.log(x); });
        
    }


    public fromdateformatcheck(date) {
        if (typeof (date) == 'string') {
            const dateformat = date.split('-');
            if (dateformat.length == 3)
                if (dateformat[0] != "" && dateformat[1] != "" && dateformat[2] != "") {

                    this.fromvalidateDate = true;
                }
                else {
                    this.fromvalidateDate = false;
                }
            else {
                this.fromvalidateDate = false;
                
            }
            
        }
        else {
            this.onFromDateChange();
        }

    }


    public todateformatcheck(date) {
        if (typeof (date) == 'string') {
            const dateformat = date.split('-');
            if (dateformat.length == 3)
                if (dateformat[0] != "" && dateformat[1] != "" && dateformat[2] != "") {

                    this.tovalidateDate = true;
                }
                else {
                    this.tovalidateDate = false;
                }
            else {
                this.tovalidateDate = false;
            }
        }else {
           this.onToDateChange();
            }

        }

    public onFromDateChange() { 
        if (!this.selectedFromDate) {

            this.validateFromDate = true;
            this.validateSet = false;
            this.validated = false;
            this.validateToDate = false;

        }
        else {
            this.validateFromDate = false;

        }

        if (this.selectedToDate != undefined && this.selectedFromDate != undefined) {
            const start = new Date(this.selectedFromDate.year, this.selectedFromDate.month - 1, this.selectedFromDate.day);
            const end = new Date(this.selectedToDate.year, this.selectedToDate.month - 1, this.selectedToDate.day);
            
            if (start > end) {
                this.validateDate = true;
            }
            else {
                this.validateDate = false;
                this.fromvalidateDate = true;
            }
        }
        this.setValuesToMasterDataObj();
    }



    public onToDateChange() {
        if (!this.selectedToDate) {
            this.validateToDate = true;
            this.validateFromDate = false;
            this.validateSet = false;
            this.validated = false;
        }
        else {
            this.validateToDate = false;
            this.tovalidateDate = true;

        }

        if (this.selectedToDate != undefined && this.selectedFromDate != undefined) {
            const start = new Date(this.selectedFromDate.year, this.selectedFromDate.month - 1, this.selectedFromDate.day);
            const end = new Date(this.selectedToDate.year, this.selectedToDate.month - 1, this.selectedToDate.day);
            if (start > end) { 
                this.validateDate = true;
            }
            else {
                this.validateDate = false;
            }
        }

        this.setValuesToMasterDataObj();
    }

    public onChangeSet(event:Event) { 
        const target = event?.target as HTMLInputElement; // Perform type assertion here
        const setvalue = parseInt(target?.value,10);

        this.selectedData = this.setData.filter(x => x.ID == setvalue);
        if (this.selectedData.length > 0)
            this.selectedName = this.selectedData[0].Name;
        if (setvalue != 0)
            this.validateSet = false;
        this.selectedVersion = 0;  
        if(setvalue == 27){
          this.displayVersionField = true;
        }
        else{
          this.displayVersionField = false;
        }
        this.setValuesToMasterDataObj();
    }
     
    // public getDisableDates(startDate, endDate) {
    //     var start = new Date(startDate);
    //     var end = new Date(endDate);
    //     for (let i = 0; start <= end; i++) {
    //         this.model = { "year": start.getFullYear(), "month": start.getMonth() + 1, "day": start.getDate() }
    //         this.disabledDates.push(this.model);
    //         start.setDate(start.getDate() + 1);
    //     }
    // }

    public validateFields() {

        if (this.selectedData.length == 0) {

            this.validateSet = true;
            this.validated = false;
            this.validateToDate = false;
            this.validateFromDate = false;
            return this.validated;
        }
        else if (!this.selectedFromDate) {

            this.validateFromDate = true;
            this.validateSet = false;
            this.validated = false;
            this.validateToDate = false;
            return this.validated;
        }
        else if (!this.selectedToDate) {

            this.validateToDate = true;
            this.validateSet = false;
            this.validateFromDate = false;
            this.validated = false;
            return this.validated;
        }  else if (this.displayVersionField && (!this.selectedVersion || this.selectedVersion === 0)) { 
        this.validated = false;
        this.validateVersion = true;
        return this.validated;
    }

        this.validateToDate = false;
        this.validateSet = false;
        this.validateFromDate = false;
        this.validated = true;
        this.validateVersion = false;
        return this.validated;
    }

    public onReportBtnClick(reportType: string) {
        this.validateFields();
        if (this.validated && !this.validateDate && this.fromvalidateDate && this.tovalidateDate) {
            const start = new Date(this.selectedFromDate.year, this.selectedFromDate.month - 1, this.selectedFromDate.day);
            const end = new Date(this.selectedToDate.year, this.selectedToDate.month - 1, this.selectedToDate.day);

            this.showLoader = true;

            this.additionalservice.getSetReport(reportType, this.selectedData[0].ID, this.datePipe.transform(start, 'MM/dd/yy'), this.datePipe.transform(end, 'MM/dd/yy'),this.selectedVersion).subscribe(res => {
                const binaryData = [];

                binaryData.push(res);
                const url = window.URL.createObjectURL(new Blob(binaryData, { type: 'application/vnd.ms-excel' }));
                // create hidden dom element (so it works in all browsers)
                const a = document.createElement('a');
                a.setAttribute('style', 'display:none;');
                document.body.appendChild(a);
                // create file, attach to hidden element and open hidden element
                a.href = url;
                a.download = reportType + "Report.xls";
                a.click();
                this.showLoader = false;

            });




        }

        this.setValuesToMasterDataObj();
    }

    public autoPopulateOnTabChange() {

        const additionalQuestionData = this.masterDataService.additionalQuestionInputs;

        if (additionalQuestionData) {
            this.selectedName =  additionalQuestionData.selectedName || 0;
            this.validateToDate = additionalQuestionData.validateToDate || false;
            this.validateSet = additionalQuestionData.validateSet || false;
            this.validateFromDate = additionalQuestionData.validateFromDate || false;
            this.validated = additionalQuestionData.validated || false;
            this.validateDate =  additionalQuestionData.validateDate || false;
            this.selectedFromDate = additionalQuestionData.selectedFromDate || "";
            this.selectedToDate = additionalQuestionData.selectedToDate || "";
            this.selectedData = additionalQuestionData.selectedData || [];
            this.selectedSet = additionalQuestionData.selectedSet || 0;


        }
    }

    public setValuesToMasterDataObj() {
        const data = {
            selectedName: this.selectedName,
            validateToDate: this.validateToDate,
            validateSet: this.validateSet,
            validateFromDate: this.validateFromDate,
            validated: this.validated,
            validateDate: this.validateDate,
            selectedFromDate: this.selectedFromDate,
            selectedToDate: this.selectedToDate,
            selectedData: this.selectedData,
            selectedSet: this.selectedSet,
            //mainGridData: this.mainGridData,
            //nonRegisterGridData: this.nonRegisterGridData,
            //reg: this.registerGridData,
        }
        this.masterDataService.additionalQuestionInputs = data;
    }
}

